import { createTheme } from "@material-ui/core/styles"
import { FONT_FAMILY_REGULAR } from "../utils"

export const darkTheme = createTheme({
  palette: {
    type: "dark",
    background: {
      default: "#002845",
      paper: "#002845",
    },
    primary: {
      main: "#3f50b5",
    },
    secondary: {
      main: "#002845",
    },
  },
  typography: {
    fontFamily: FONT_FAMILY_REGULAR,
  },
  overrides: {
    MuiListItem: {
      //FIXME: Tweak for supporting sidebar menu
      gutters: {
        paddingLeft: "16px !important",
        paddingRight: "16px !important",
      },
    },
  },
})
